import { render, staticRenderFns } from "./RealizaVoto.vue?vue&type=template&id=96a96f78&scoped=true"
import script from "./RealizaVoto.vue?vue&type=script&lang=js"
export * from "./RealizaVoto.vue?vue&type=script&lang=js"
import style0 from "./RealizaVoto.vue?vue&type=style&index=0&id=96a96f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a96f78",
  null
  
)

export default component.exports